import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { Link } from 'gatsby-theme-material-ui';
import styles from './darkStyles';

function StatisticItemDark({ value, description, link }) {
  return (
    <Box
      sx={{
        p: { xs: '4px 8px 4px 12px', xl: '8px 10px 8px 16px' },
        display: 'flex',
        alignItems: 'center',
        minWidth: { xs: 220, lg: 274 },
        minHeight: 80,
        gap: 2,
        backgroundColor: 'rgba(255, 255, 255, 0.14)',
        borderRadius: 4.5,
      }}
    >
      {value ? (
        <Typography sx={styles.value} component="p" variant="desktopH2">
          {value}
        </Typography>
      ) : (
        <Skeleton width={'100%'} height={72} />
      )}

      {!description && !link && <Skeleton width={200} height={45} />}

      <Box>
        {description && (
          <Typography
            color="kit.text.mainInverse"
            variant="desktopP3"
            sx={{ whiteSpace: 'break-spaces', fontSize: 14 }}
          >
            {description}
          </Typography>
        )}

        {link && (
          <Link
            target="_blank"
            to={link.url}
            variant="kitSecondaryInverse"
            typography="desktopP3"
            sx={{
              fontSize: {
                xs: 14,
                md: 14,
              },
            }}
          >
            {link.title}
          </Link>
        )}
      </Box>
    </Box>
  );
}

export default StatisticItemDark;
